import React, { useState, useContext, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { DateUtil, LocalDateUtil} from '@xengage/gw-portals-util-js';
import { LoaderExt } from 'gw-components-platform-react';
import { useTranslator, IntlContext } from '@jutro/locale';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import { useValidation } from '@xengage/gw-portals-validation-react';
import styles from './ClaimList.module.scss';

import {
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    DateField,
    ModalNextContext,
    // FormattedDate
    InlineLoader,
} from '@jutro/components';
import { Flex, FlexItem,Grid, GridItem } from '@jutro/layout';
import messages from '../../Claims.messages';

import { Button, RadioButtonField } from '@jutro/legacy/components';

function CEsubscriptionLossRunModal(props) {
    const {
        isOpen,
        onReject
    } = props;
    const today = DateUtil.currentDateAtMidnight();

    const yesterdayDate = () => {
        // const yesterday = new Date(today)
        // yesterday.setDate(yesterday.getDate() - 1)        
        const yesterday = LocalDateUtil.today(-1)   
        return yesterday;
    }

    const [dateSelectedValue, setDateSelectedValue] = useState(yesterdayDate);
    const { isComponentValid } = useValidation('CEsubscriptionLossRunModal');
    const [selectedRadioButtionValue, setSelectedRadioButtionValue] = useState();
    const translator = useTranslator();
    const [showIncidentOnlyRadioButtionValue, setshowIncidentOnlyRadioButtionValue] = useState("show");
    const [requestOpenClaimStatus, setOpenClaimStatus] = useState(false);
    const ModalNextAlert = useContext(ModalNextContext);
    const [requestAllClaimStatus, setAllClaimStatus] = useState(false);
    const [requestClosedClaimStatus, setClosedClaimStatus] = useState(false);
    const [requestClaimAnalysisStatus, setClaimAnalysisStatus] = useState(false);
    const [requestClaimHistory, setRequestClaimHistory] = useState(false);
    const [requestClaimExtract, setRequestClaimExtract] = useState(false);
    const [isLoading, setLoadingState] = useState(true);
    const [isInlineLoading, setInlineLoadingState] = useState(false);
    const [isLossRunDownloading, setIsLossRunDownloading] = useState(false);
    const [showHideFlag, setShowHideFlag] = useState(false);
    const [pdfclaimsonlyLabel, setPdfclaimsonlyLabel] = useState("none");
    const [dynamicWidth,setDynamicWidth] = useState('43%');
    const [downloadDisable,setDownloadDisable] = useState(false);
    const intl = useContext(IntlContext);


    useEffect(()=>{

    },[dynamicWidth])


    useEffect(() => {
        
        const allClaim = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'ClaimStatusReport',
                claimStatus: 'all',
                emailID: props.email,
            },

        ];
        GatewayClaimService.reportStatus(allClaim, props.authHeader).then((res) => {
            setLoadingState(false);
            // setOpenClaimStatus(res);
            setAllClaimStatus(res);

        });
        const openclaim = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'ClaimStatusReport',
                claimStatus: 'open',
                emailID: props.email,
            },
        ];
        GatewayClaimService.reportStatus(openclaim, props.authHeader).then((res) => {
            setOpenClaimStatus(res);

        })
        const closedClaims = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'ClaimStatusReport',
                claimStatus: 'Closed',
                emailID: props.email,
            },
        ];
        GatewayClaimService.reportStatus(closedClaims, props.authHeader).then((res) => {
            setClosedClaimStatus(res);
        })
        const lossHistory = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'CELoss',
                emailID: props.email,
                claimStatus: 'loss',
            },
        ];
        GatewayClaimService.reportStatus(lossHistory, props.authHeader).then((res) => {
            setRequestClaimHistory(res);
        })
        const lossHistoryExtract = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'CELoss',
                emailID: props.email,
                claimStatus: 'extract',
            },
        ];
        GatewayClaimService.reportStatus(lossHistoryExtract, props.authHeader).then((res) => {
            setRequestClaimExtract(res);
        })
        const lossRun = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'PLoss',
            },
        ];
        GatewayClaimService.reportStatus(lossHistory, props.authHeader).then((res) => {
            // setRequestLossRun(res);
        })

        const claimAnalysis = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'CARReport',
                emailID: props.email
            },
        ];
        GatewayClaimService.reportStatus(claimAnalysis, props.authHeader).then((res) => {
            setClaimAnalysisStatus(res);
        })
    }, [props.accountNumber, props.authHeader, props.email, props.policyNumber, showHideFlag]);

    const handleClose = useCallback(() => {
        onReject();
    }, [onReject]);

    // useEffect(() => {
    //     if (isLossRunDownloading) {
    //         setTimeout(() => {
    //             downloadLossRun();
    //         }, 8000);
    //     }
    // }, [downloadLossRun, isLossRunDownloading]);

    const losRunClick = () => {
        setDynamicWidth('44%');
        setShowHideFlag(true);
        setPdfclaimsonlyLabel('inline-block');
    }

    const downloadLossRun = () => {
        setIsLossRunDownloading(true);
        const asOfDate = LocalDateUtil.toMidnightDate(dateSelectedValue)
        let format = selectedRadioButtionValue
        let hideIncidentOnly;
        if(showIncidentOnlyRadioButtionValue === "show"){
            hideIncidentOnly = false
        }else if(showIncidentOnlyRadioButtionValue === "donotshow"){
            hideIncidentOnly = true
        }
        if(selectedRadioButtionValue === "pdf"){
            format = "PDF"
        }else if(selectedRadioButtionValue === "excel"){
            format = "XLS"
        }
        const reportDTO =
        {
            "policyNumber": props.policyNumber,
            "accountNumber": props.accountNumber,
            "emailID": props.email,
            "asOfDate": asOfDate,
            "format"  : format,
            'hideIncidentOnly': hideIncidentOnly 
        };

        setInlineLoadingState(true)
        GatewayClaimService.lossRunRealTimeReport(reportDTO, props.authHeader)
            .then((res) => {
                // res.base64 = "{message=Report is in-progress, dateTime=2022-09-16T12:20:14.975Z}";
                if (res.base64) {
                    if (res.base64 && res.base64.indexOf('Report') > -1) {
                        setIsLossRunDownloading(false);
                        // setTimeout(()=>{
                        //     if(isLossRunDownloading){
                        //         setTimeout(()=>{
                        //             downloadLossRun();
                        //         },8000); 
                        //     }   
                        // }, 2000);
                    } else {
                        setIsLossRunDownloading(false);
                        const linkSource = `data:application/pdf;base64,${res.base64}`;
                        let fileName = "";
                        if(selectedRadioButtionValue === "pdf"){
                            fileName = "LossRun.pdf"
                        }else if(selectedRadioButtionValue === "excel"){
                            fileName = "LossRun.xls"
                        }
                        const a = document.createElement('a');
                        document.body.appendChild(a);
                        a.href = linkSource;
                        a.download = fileName;
                        a.click();
                    }
                } else {
                    ModalNextAlert.showAlert({
                        title: 'Error',
                        message: 'Sorry, an error occurred. Please try later or contact copperpointlossruns@copperpoint.com.',
                        status: 'error',
                        icon: 'mi-error-outline'
                    });
                }
            }).catch((error) => {

                ModalNextAlert.showAlert({
                    title: 'Error',
                    message: 'Sorry, an error occurred. Please try later or contact copperpointlossruns@copperpoint.com.',
                    status: 'error',
                    icon: 'mi-error-outline'
                });
            }).finally(() => {
                // setLoadingState(false);
                setInlineLoadingState(false)
            });
    };

    function renderLoader(isInlineLoading) {
        return isInlineLoading ? <InlineLoader loading={isInlineLoading} className="gw-inline-loader" /> : null;
    }

    // if (isLoading) {
    //     // eslint-disable-next-line react/react-in-jsx-scope
    //     return <LoaderExt loaded={isLoading} />;
    // }

    const handleDateChange = (value) => {

        // const d = new Date(value)
        // const dateval = moment(d).format("MM-DD-YYYY");

        // const newdate = moment(value).toDate();
        // moment(newdate).format('MM/DD/YYYY');

        // const dateVal =  intl.formatDate(new Date(value), { year: 'numeric', month: 'numeric', day: 'numeric' })
        setDateSelectedValue(value);
        
        const selectedDate =  DateUtil.dateYearsAgo(value,0)

        const minDate=DateUtil.dateYearsAgo(today,2)
        const maxDate = new Date(new Date().getTime()-(1*24*60*60*1000))  

        if(!(DateUtil.dateYearsAgo(today,2) < selectedDate && selectedDate <= new Date(new Date().getTime()-(1*24*60*60*1000)))){
            setDownloadDisable(true)
        } else{
            setDownloadDisable(false)
        }

    }



    const radioButtionChangeFUnction = (value) => {
        setSelectedRadioButtionValue(value);
    }

    const radioButtonShowInciOnlyClaimChangeFunction = (value) => {
        setshowIncidentOnlyRadioButtionValue(value);
    }

    const renderAllClaimsOpen = useCallback(() => {
        const openClaimStatus = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'ClaimStatusReport',
                claimStatus: 'open',
                emailID: props.email,
            },
        ];
        ModalNextAlert.showConfirm({
            title: messages.ClaimStatusTitle,
            message: translator(messages.ClaimStatus, {
                email: props.email,
            }),
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.claimHistoryCancel,
        }).then((results) => {
            if (results === 'confirm') {
                try {
                    setOpenClaimStatus(false);
                    const openClaimStatusReport = GatewayClaimService.requestReport(
                        openClaimStatus,
                        props.authHeader
                    ).then((res) => {
                        setOpenClaimStatus(false);

                    });

                } catch (documentDeletionError) {
                    ModalNextAlert.showAlert({
                        title: messages.documentDeletionFailed,
                        message: messages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'OK',
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }, [props.accountNumber, props.policyNumber, props.email, props.authHeader, ModalNextAlert, translator]);

    const renderAllClaimsStatus = useCallback(() => {
        const allClaimStatus = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'ClaimStatusReport',
                claimStatus: 'all',
                emailID: props.email,
            },
        ];
        ModalNextAlert.showConfirm({
            title: messages.ClaimStatusTitle,
            message: translator(messages.ClaimStatus, {
                email: props.email,
            }),
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.claimHistoryCancel,
        }).then((results) => {
            if (results === 'confirm') {
                try {
                    setAllClaimStatus(false);
                    const allClaimStatusReport = GatewayClaimService.requestReport(
                        allClaimStatus,
                        props.authHeader
                    ).then((res) => {

                        // setAllClaimStatus(true);
                        setAllClaimStatus(false);
                    });
                } catch (documentDeletionError) {
                    ModalNextAlert.showAlert({
                        title: messages.documentDeletionFailed,
                        message: messages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'OK',
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }, [props.accountNumber, props.policyNumber, props.email, props.authHeader, ModalNextAlert, translator]);

    const renderAllClaimsClosed = useCallback(() => {
        const closedClaimStatus = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'ClaimStatusReport',
                claimStatus: 'Closed',
                emailID: props.email,
            },
        ];
        ModalNextAlert.showConfirm({
            title: messages.ClaimStatusTitle,
            message: translator(messages.ClaimStatus, {
                email: props.email,
            }),
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.claimHistoryCancel,
        }).then((results) => {
            if (results === 'confirm') {
                try {
                    setClosedClaimStatus(false);
                    const closedClaimStatusReport = GatewayClaimService.requestReport(
                        closedClaimStatus,
                        props.authHeader
                    ).then((res) => {

                        setClosedClaimStatus(false);
                    });

                } catch (documentDeletionError) {
                    ModalNextAlert.showAlert({
                        title: messages.documentDeletionFailed,
                        message: messages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'OK',
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }, [ModalNextAlert, props.accountNumber, props.authHeader, props.email, props.policyNumber, translator]);

    const requestClaimAnalysis = useCallback(() => {
        const claimAnalysis = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'CARReport',                
                emailID: props.email,
            },
        ];
        ModalNextAlert.showConfirm({
            title: messages.ClaimAnalysisTitle,
            message: translator(messages.ClaimAnalysis, {
                email: props.email,
            }),
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.claimHistoryCancel,
        }).then((results) => {
            if (results === 'confirm') {
                try {
                    setClaimAnalysisStatus(false);
                    const closedClaimStatusReport = GatewayClaimService.requestReport(
                        claimAnalysis,
                        props.authHeader
                    ).then((res) => {
                        setClaimAnalysisStatus(false)                        
                    });

                } catch (documentDeletionError) {
                    ModalNextAlert.showAlert({
                        title: messages.documentDeletionFailed,
                        message: messages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'OK',
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }, [ModalNextAlert, props.accountNumber, props.authHeader, props.email, props.policyNumber, translator]);

    const renderClaimsHistory = useCallback(() => {
        const reportLossHistoryDto = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                reportType: 'CELoss',
                emailID: props.email,
                claimStatus: 'loss'
            },
        ];
        ModalNextAlert.showConfirm({
            title: messages.claimHistoryTitle,
            message: translator(messages.claimHistoryMessage, {
                email: props.email,
            }),
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.claimHistoryCancel,
        }).then((results) => {
            if (results === 'confirm') {
                try {
                    setRequestClaimHistory(false);
                    const claimsHistoryReport = GatewayClaimService.requestReport(
                        reportLossHistoryDto,
                        props.authHeader
                    ).then((res) => {

                        setRequestClaimHistory(false);
                    });

                } catch (documentDeletionError) {
                    ModalNextAlert.showAlert({
                        title: messages.documentDeletionFailed,
                        message: messages.documentCannotDeleted,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'OK',
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }, [props.accountNumber, props.policyNumber, props.email, props.authHeader, ModalNextAlert, translator]);

    const renderClaimsExtract = useCallback(() => {
        const claimExtractLossHistoryDto = [
            {
                accountNumber: props.accountNumber,
                policyNumber: props.policyNumber,
                emailID: props.email,
                reportType: 'CELoss',
                format: 'XLS'
            },
        ];
               
        GatewayClaimService.lossRunExtractRealTimeReport(claimExtractLossHistoryDto, props.authHeader)
            .then((res) => {
                if (res.base64) {
                    if (res.base64 && res.base64.indexOf('Report') > -1) {
                        //setRequestDetailLossExtractButtondisabled(false); NEED TO WROK ON THIS

                    } else {
                        //setRequestDetailLossExtractButtondisabled(false); need to work on this
                        const linkSource = `data:application/pdf;base64,${res.base64}`;
                        const fileName = "LossRunExtract.xls";
                        const a = document.createElement('a');

                        document.body.appendChild(a);
                        a.href = linkSource;
                        a.download = fileName;
                        a.click();

                        const reportLossHistoryExtractDto = [
                            {
                                accountNumber: props.accountNumber,
                                policyNumber: props.policyNumber,
                                reportType: 'CELoss',
                                emailID: props.email,
                                claimStatus: 'extract',
                            },
                        ];                                
                        const claimsHistoryReportExtract = GatewayClaimService.requestReport(
                            reportLossHistoryExtractDto,
                            props.authHeader
                        ).then((res) => {

                            setRequestClaimExtract(false);
                        });
                    }
                } else {
                    ModalNextAlert.showAlert({
                        title: 'Error',
                        message: 'Sorry, an error occurred. Please try later or contact copperpointlossruns@copperpoint.com.',
                        status: 'error',
                        icon: 'mi-error-outline'
                    });
                }
            });                
    }, [props.accountNumber, props.policyNumber, props.email, props.authHeader, ModalNextAlert, translator]);


    return (
        <ModalNext isOpen={isOpen} className="modalClass">
           <div style={{background:'#f5861f', 'border-radius':'2px'}}></div><div><ModalHeader title="Loss Runs and Claims Reports" /></div>

            {isLoading?
            <ModalBody>
                <LoaderExt loaded={isLoading} />
            </ModalBody>
            :
            <div style={{paddingLeft:'25px', 'overflow-y': 'auto'}}>
            <ModalBody
                contentLayout={{
                    component: 'grid'
                }}
            >
                <Grid id="flex" 
                columns={['50%', '50%']}
                >
                    <GridItem style={{borderRight:'1px solid #cccccc',paddingRight:'20px'}}>
                        <div>

                                <Button id="lossRunBtn" onClick={losRunClick} style={{
                                    'width':'290px',
                                    'margin-bottom': '30px'
                                }} >Loss Run</Button>
                                <Button 
                                style={{
                                    // 'margin-right': '15px',
                                    'margin-bottom': '15px', 
                                    'width':'290px'
                                }}
                                    icon="gw-file-download"
                                    onClick={renderClaimsExtract}                                
                                >
                                    Detail Loss Extract (Excel)
                                </Button>

                                <DateField
                                    id="completionDate"
                                    path="completionDate"
                                    label="Please select a valuation date within last 24 months."
                                    displayFormat="vshort"                                
                                    visible={showHideFlag}
                                    minDate={DateUtil.dateYearsAgo(today,2)}
                                    maxDate={new Date(new Date().getTime()-(1*24*60*60*1000))}                                
                                    className="datePickerSize"
                                    placeholder="MM/DD/YYYY"
                                    value={dateSelectedValue}
                                    onValueChange={handleDateChange} />

                                    <div style={{
                                        'width': '100%', 'display': 'flex',
                                        'flex-direction': 'row', gap: '20px'
                                    }}>
                                        <div>
                                            <div style={{
                                                color: 'var(--GW-FIELD-COMPONENT-COLOR)',
                                                'font-weight': 'var(--GW-FONT-WEIGHT-REGULAR)',
                                                display: pdfclaimsonlyLabel,
                                                position: 'relative',
                                                'font-size': 'var(--GW-FONT-SIZE-LABEL)',
                                                'line-height': 'var(--GW-LINE-HEIGHT-LABEL)',
                                            }} >File format
                                            </div>
                                            <RadioButtonField
                                                availableValues={[
                                                    {
                                                        displayName: 'PDF',
                                                        id: 'pdf'
                                                    },
                                                    {
                                                        displayName: 'Excel',
                                                        id: 'excel'
                                                    }

                                                ]}
                                                id="radio-button-field"
                                                label=""
                                                visible={showHideFlag}
                                                // onBlur={function noRefCheck() { }}
                                                // onFocus={function noRefCheck() { }}
                                                // onValidationChange={function noRefCheck() { }}
                                                onValueChange={radioButtionChangeFUnction}
                                                value={selectedRadioButtionValue}
                                                className={styles.radioButtonPlainText} />
                                        </div>
                                        <div>
                                            <div style={{
                                                color: 'var(--GW-FIELD-COMPONENT-COLOR)',
                                                'font-weight': 'var(--GW-FONT-WEIGHT-REGULAR)',
                                                display: pdfclaimsonlyLabel,
                                                position: 'relative',
                                                'font-size': 'var(--GW-FONT-SIZE-LABEL)',
                                                'line-height': 'var(--GW-LINE-HEIGHT-LABEL)',
                                            }} >Incident-Only Claims
                                            </div>
                                            <RadioButtonField
                                                availableValues={[
                                                    {
                                                        displayName: 'Show',
                                                        id: 'show'
                                                    },
                                                    {
                                                        displayName: 'Do Not Show',
                                                        id: 'donotshow'
                                                    }

                                                ]}
                                                id="radio-button-field"
                                                label=""
                                                visible={showHideFlag}
                                                onValueChange={radioButtonShowInciOnlyClaimChangeFunction}
                                                value={showIncidentOnlyRadioButtionValue} 
                                                className={styles.radioButtonPlainText} />
                                        </div>
                                    </div>    
                            </div>
                       
                    </GridItem>
                    <GridItem>
                        <div >

                            <Button 
                            style={{
                                // 'margin-right': '15px',
                                'margin-bottom': '15px','width':'290px',
                                'display':props.userDataInfo?'block':'none'
                                // , 'margin-left': '-8px'
                            }}
                                icon="gw-email"
                                onClick={renderAllClaimsStatus}
                                disabled={!requestAllClaimStatus}
                                visible={false}
                            >
                                Request Claim Status (All)
                            </Button>
                            <Button 
                            style={{
                                // 'margin-right': '15px',
                                'margin-bottom': '15px', 
                                'margin-top': '15px',
                                'width':'290px',
                                'display':props.userDataInfo?'block':'none'
                            }}
                                icon="gw-email"
                                onClick={renderAllClaimsOpen}
                                disabled={!requestOpenClaimStatus}
                                visible={props.userDataInfo}
                            >
                                Request Claim Status (Open)
                            </Button>
                            <Button 
                            style={{
                                // 'margin-right': '12px', 
                                // 'margin-left': '-8px',
                                'margin-bottom': '15px',
                                'width':'290px',
                                'margin-top': '15px' ,
                                'display':props.userDataInfo?'block':'none'
                                //, width:dynamicWidth
                            }}
                                icon="gw-email"
                                onClick={renderAllClaimsClosed}
                                disabled={!requestClosedClaimStatus}
                                visible={props.userDataInfo}
                            >
                                Request Claim Status (Closed)
                            </Button>
                            <Button 
                            style={{
                                // 'margin-right': '12px', 
                                // 'margin-left': '-8px',
                                'margin-bottom': '15px',
                                'width':'290px',
                                'margin-top': '15px' ,
                                'display':props.userDataInfo?'block':'none'
                                //, width:dynamicWidth
                            }}
                                icon="gw-email"
                                onClick={requestClaimAnalysis}
                                disabled={!requestClaimAnalysisStatus}
                                visible={props.userDataInfo}
                            >
                                Request Claim Analysis
                            </Button>
                            <Button 
                            style={{
                                // 'margin-right': '15px',
                                'margin-bottom': '15px', 
                                'width':'290px'
                            }}
                                icon="gw-email"
                                onClick={renderClaimsHistory}
                                disabled={!requestClaimHistory}
                            >
                                Request Claim History (Excel)
                            </Button>                            
                        </div>
                    </GridItem>

                </Grid>
                <div><Button id="lossRunBtn" disabled={(!selectedRadioButtionValue || isLossRunDownloading) || downloadDisable} onClick={downloadLossRun} icon="gw-file-download" style={{'width':'290px', 'display': showHideFlag ? 'block' : 'none' }} >{isLossRunDownloading ? "Please wait..." : 'Download Loss Run'}</Button></div>
            </ModalBody>
            </div>
}
<div style={{background:"#ebebeb",borderTop:'1px solid orange'}}><ModalFooter style={{'background-color':'#ebebeb'}}>
               
                <Button onClick={handleClose} style={{'min-width':'145px'}} type="outlined">
                    Close
                </Button>

            </ModalFooter></div>
        </ModalNext>
    );
}

CEsubscriptionLossRunModal.propTypes = {
    notesVM: PropTypes.shape({}).isRequired,
    title: PropTypes.string.isRequired,
    // actionBtnLabel: PropTypes.shape({}).isRequired,
    // cancelBtnLabel: PropTypes.shape({}).isRequired,
    onReject: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func.isRequired
};



export default CEsubscriptionLossRunModal;
